import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { useGetUsersSettingsQuery } from '../../api/v2/users'
import { useMyContext } from '../../context/context'
import useSettingsV2 from '../../hooks/useSettingsV2'

const UsersContext = createContext()

export function UsersProvider({ children }) {
  const [usersHeaders, setUsersHeaders] = useState([])
  const [usersFilters, setUsersFilters] = useState([])
  const [currentSettings, setCurrentSettings] = useState()

  const { settings: settingsFo } = useSettingsV2()

  const { myContext } = useMyContext()
  const { data: settings } = useGetUsersSettingsQuery({ ...myContext, settingsId: settingsFo?.FO_MEETING_STATS_SETTINGS_ID })

  useEffect(() => {
    if (settings) {
      setCurrentSettings(settings)
    }
  }, [settings])

  useEffect(() => {
    if (currentSettings) {
      setUsersFilters(currentSettings.usersFilters)
      setUsersHeaders(currentSettings.usersHeaders)
    }
  }, [currentSettings])

  const state = useMemo(
    () => ({
      usersHeaders,
      setUsersHeaders,
      usersFilters,
      setUsersFilters,
      currentSettings,
      setCurrentSettings,
    }),
    [usersHeaders, setUsersHeaders, usersFilters, setUsersFilters, currentSettings, setCurrentSettings]
  )

  return <UsersContext.Provider value={state}>{children}</UsersContext.Provider>
}

export const useUsers = () => useContext(UsersContext)
